import { render, staticRenderFns } from "./InscribirView.vue?vue&type=template&id=42ef5971&scoped=true"
import script from "./InscribirView.vue?vue&type=script&lang=js"
export * from "./InscribirView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef5971",
  null
  
)

export default component.exports